
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-a95ff598&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ShopPageQr.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./ShopPageQr.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-a95ff598!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ShopPageQr.vue"),
  /* scopeId */
  "data-v-a95ff598",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Shop/ShopPageQr.vue
// module id = 652
// module chunks = 0